import { apiAutNFe } from '../shared/api-functions'
import { apiORDS } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  methods: {

    // apiCarregaProduto (nfit) {
    //   // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
    //   let self = this

    //   this.$store.dispatch('loadItem', { id: nfit.coditem }).then(function () {
    //     self.apiCarregaDadosProduto(nfit, self.$store.getters.getItem, null)
    //   })

    //   this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade }).then(function () {
    //     self.apiCarregaDadosProduto(nfit, null, self.$store.getters.getItemTaxes)
    //   })

    // },

    async apiCarregaProduto(nfit) {
      // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
      let self = this

      await this.$store.dispatch('loadItem', { id: nfit.coditem })
      await this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade })
      this.apiCarregaDadosProduto(nfit, this.$store.getters.getItem, this.$store.getters.getItemTaxes)

    },

    async apiCarregaIvaclass(nfit) {
      // ROTINA EXECUTADA AO SELECIONAR UM ITEM PARA A NOTA
      let self = this

      await this.$store.dispatch('loadItem', { id: nfit.coditem })
      await this.$store.dispatch('loadItemTaxes', { codnf: nfit.codnf, coditem: nfit.coditem, finalidade: nfit.finalidade, ibscbscclass: nfit.ibscbscclass })
      this.apiCarregaDadosIvaclass(nfit, this.$store.getters.getItem, this.$store.getters.getItemTaxes)

    },


    apiCarregaDadosProduto(nfit, item, itemTaxes) {
      if (item) {
        nfit.uni = item[0].uni
        nfit.ncm = item[0].ncm
        nfit.orimerc = item[0].orimerc
        nfit.indtot = 'S'
        nfit.inddup = 'S'
        //agrega o objeto retornado pela API ao objeto NFIT
        nfit.item = item

        nfit.vlr = 0;
        if (item[0].precovenda)
          nfit.vlr = item[0].precovenda

        try {
          if (nfit.operacaonf == 'E') {
            nfit.vlr = 0
          }
        } catch (e) {

        }


      }
      if (itemTaxes) {
        nfit.nfci = itemTaxes.nfci
        nfit.csosn = itemTaxes.csosn
        nfit.sticm = itemTaxes.sticm
        nfit.stpis = itemTaxes.stpis
        nfit.stcofins = itemTaxes.stcofins
        nfit.stipi = itemTaxes.stipi
        nfit.cfop = itemTaxes.cfop
        nfit.motdesicm = itemTaxes.motdesicm
        nfit.cest = itemTaxes.cest
        nfit.aicm = itemTaxes.aicm
        nfit.ricm = itemTaxes.ricm
        nfit.afcp = itemTaxes.afcp
        nfit.aicmst = itemTaxes.aicmst
        nfit.mva = itemTaxes.mva
        nfit.pautaicm = itemTaxes.pautaicm
        nfit.pautaicmst = itemTaxes.pautaicmst
        nfit.ricmst = itemTaxes.ricmst
        nfit.afcpst = itemTaxes.afcpst
        nfit.picmdif = itemTaxes.picmdif

        nfit.pdesicm = itemTaxes.pdesicm
        nfit.pdespc = itemTaxes.pdespc

        nfit.particmdest = itemTaxes.particmdest
        nfit.aicmdest = itemTaxes.aicmdest
        nfit.afcpdest = itemTaxes.afcpdest

        nfit.bcipi = 0
        nfit.vipi = 0
        nfit.aipi = itemTaxes.aipi
        nfit.ripi = itemTaxes.ripi
        nfit.pautaipi = itemTaxes.pautaipi
        nfit.cenqipi = itemTaxes.cenqipi

        nfit.bcpis = 0
        nfit.vpis = 0
        nfit.apis = itemTaxes.apis
        nfit.apisst = itemTaxes.apisst
        nfit.rpis = itemTaxes.rpis
        nfit.pautapis = itemTaxes.pautapis
        nfit.pautapisst = itemTaxes.pautapisst

        // nfit.atribest = itemTaxes.atribest
        // nfit.atribfed = itemTaxes.atribfed
        // nfit.atribimp = itemTaxes.atribimp
        // nfit.atribmun = itemTaxes.atribmun

        nfit.bccofins = 0
        nfit.vcofins = 0
        nfit.acofins = itemTaxes.acofins
        nfit.acofinsst = itemTaxes.acofinsst
        nfit.rcofins = itemTaxes.rcofins
        nfit.pautacofins = itemTaxes.pautacofins
        nfit.pautacofinsst = itemTaxes.pautacofinsst

        nfit.stiss = itemTaxes.stiss
        nfit.aiss = itemTaxes.aiss

        nfit.ibscbscclass = itemTaxes.ibscbscclass

        nfit.ibsufaliq = itemTaxes.ibsufaliq
        nfit.ibsufred = itemTaxes.ibsufred

        nfit.ibsmunaliq = itemTaxes.ibsmunaliq
        nfit.ibsmunred = itemTaxes.ibsmunred

        nfit.cbsaliq = itemTaxes.cbsaliq
        nfit.cbsred = itemTaxes.cbsred

        nfit.ccredpres = itemTaxes.ibsccredpres
        nfit.ibspcredpres = itemTaxes.ibspcredpres
        nfit.ibsvcredprescondsus = itemTaxes.ibsvcredprescondsus

        nfit.cbspcredpres = itemTaxes.cbspcredpres
        nfit.cbsvcredprescondsus = itemTaxes.cbsvcredprescondsus

        // nfit.bcicmsret

      }


    },

    apiCarregaDadosIvaclass(nfit, item, itemTaxes) {
      if (itemTaxes) {
        nfit.ibscbscclass = itemTaxes.ibscbscclass

        nfit.ibsufaliq = itemTaxes.ibsufaliq
        nfit.ibsufred = itemTaxes.ibsufred

        nfit.ibsmunaliq = itemTaxes.ibsmunaliq
        nfit.ibsmunred = itemTaxes.ibsmunred

        nfit.cbsaliq = itemTaxes.cbsaliq
        nfit.cbsred = itemTaxes.cbsred

        nfit.ccredpres = itemTaxes.ibsccredpres
        nfit.ibspcredpres = itemTaxes.ibspcredpres
        nfit.ibsvcredprescondsus = itemTaxes.ibsvcredprescondsus

        nfit.cbspcredpres = itemTaxes.cbspcredpres
        nfit.cbsvcredprescondsus = itemTaxes.cbsvcredprescondsus

        // nfit.bcicmsret

      }


    },






  }
}





// WEBPACK FOOTER //
// ./src/api/api-nf-item.js